import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import Character from '../models/Game Layer/character';
import Player from '../models/Game Layer/player';
import Session from '../models/Game Layer/session';

@Injectable({
  providedIn: 'root',
})
export class GamelayerService {

  private mainUrl = environment.apiUrl + '/gamelayer';

  constructor(private http: HttpClient) { }

  // Session-related methods
  getSessions():Observable<Session[]> {
    return this.http.get<Session[]>(`${this.mainUrl}/sessions`);
  }

  getSessionById(sessionId: string): Observable<Session> {
    return this.http.get<Session>(`${this.mainUrl}/sessions/${sessionId}`);
  }

  postSession(sessionData: any): Observable<Session> {
    return this.http.post<Session>(`${this.mainUrl}/sessions`, sessionData);
  }

  updateSession(sessionId: string, sessionData: any): Observable<Session> {
    return this.http.put<Session>(`${this.mainUrl}/sessions/${sessionId}`, sessionData);
  }

  deleteSession(sessionId: string): Observable<Session> {
    return this.http.delete<Session>(`${this.mainUrl}/sessions/${sessionId}`);
  }

  joinSession(sessionId: string, playerData: Partial<Player>): Observable<Session> {
    return this.http.post<Session>(`${this.mainUrl}/sessions/${sessionId}/players`, playerData);
  }

  // Character-related methods
  getCharacters(sessionId: string): Observable<Character[]> {
    return this.http.get<Character[]>(`${this.mainUrl}/sessions/${sessionId}/characters`);
  }

  getCharacterById(sessionId: string, characterId: string): Observable<Character> {
    return this.http.get<Character>(`${this.mainUrl}/sessions/${sessionId}/characters/${characterId}`);
  }

  postCharacter(sessionId: string, characterData: any): Observable<Character> {
    return this.http.post<Character>(`${this.mainUrl}/sessions/${sessionId}/characters`, characterData);
  }

  updateCharacter(sessionId: string, characterId: string, characterData: any): Observable<Character> {
    return this.http.put<Character>(`${this.mainUrl}/sessions/${sessionId}/characters/${characterId}`, characterData);
  }
  
  deleteCharacter(sessionId: string, characterId: string): Observable<Character> {
    return this.http.delete<Character>(`${this.mainUrl}/sessions/${sessionId}/characters/${characterId}`);
  }
}
